<script setup>
import {onMounted} from "vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import EmailForm from "@/components/EmailForm.vue";
import {useHead} from "@vueuse/head";


onMounted(async () => {
  const scripts = [
      '/assets/js/vendor/modernizr-2.8.3.min.js',
    '/assets/js/vendor/jquery-3.5.1.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/isotope.pkgd.min.js',
    '/assets/js/owl.carousel.min.js',
    '/assets/js/jquery.nivo.slider.pack.js',
    '/assets/js/slick.min.js',
    '/assets/js/imagesloaded.pkgd.min.js',
    '/venobox/venobox.min.js',
    '/assets/js/jquery.appear.js',
    '/assets/js/jquery.knob.js',
    '/assets/js/BeerSlider.js',
    '/assets/js/theme-pluginjs.js',
    '/assets/js/jquery.meanmenu.js',
    '/assets/js/ajax-mail.js',
    '/assets/js/theme.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  await loadScriptsSequentially(scripts);
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})
</script>

<template>
  <Header/>

  <!-- breadcumb-area -->
  <div class="breadcumb-area">
    <div class="container">
      <div class="row">
        <div class="col-md-12 txtc  text-center ccase">
          <div class="brpt">
            <h2>Contact</h2>
          </div>
          <div class="breadcumb-inner">
            <ul>
              <li><a href="/">Home</a></li>
              <li><i class="fas fa-angle-right"></i></li>
              <li>Contact</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--  &lt;!&ndash; kurigram_team_area &ndash;&gt;-->
<!--  <div class="kurigram_team_area team_style4">-->
<!--    <div class="container">-->
<!--      <div class="row">-->
<!--        <div class="col-lg-12">-->
<!--          <div class="witr_section_title">-->
<!--            <div class="witr_section_title_inner text-center">-->
<!--              <h3>Our Team</h3>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="row team_top">-->
<!--        &lt;!&ndash; kurigram_team_01 &ndash;&gt;-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12">-->
<!--          <div class="em-team all_color_team ">-->
<!--            <div class="em-team-one">-->
<!--              <div class="em-team-content-image-inner">-->
<!--                <div class="em-team-content-image">-->
<!--                  <img src="/assets/images/business1.png" alt=""/>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="em-team-content-waraper all_content_bg_color">-->
<!--                <div class="em-team-content-title-inner">-->
<!--                  <div class="em-content-title">-->
<!--                    <h5><a href="#">Ray Chan</a></h5>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-subtitle-inner">-->
<!--                  <div class="em-content-subtitle">-->
<!--                    <span>Sales Manager</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-socials-inner">-->
<!--                  <div class="em-team-content-socials all_team_s_color">-->
<!--                    <a href="https://www.facebook.com/profile.php?id=100083074701518"><i-->
<!--                        class="icofont-facebook"></i></a>-->
<!--                    <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i-->
<!--                        class="icofont-youtube"></i></a>-->
<!--                    <a href="https://api.whatsapp.com/send?phone=8613929160928"><i class="icofont-whatsapp"></i></a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; kurigram_team_02 &ndash;&gt;-->
<!--        <div class="col-lg-6 col-md-6 col-sm-12">-->
<!--          <div class="em-team all_color_team ">-->
<!--            <div class="em-team-one">-->
<!--              <div class="em-team-content-image-inner">-->
<!--                <div class="em-team-content-image">-->
<!--                  <img src="/assets/images/business2.png" alt=""/>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="em-team-content-waraper all_content_bg_color">-->
<!--                <div class="em-team-content-title-inner">-->
<!--                  <div class="em-content-title">-->
<!--                    <h5><a href="#">Kary Huang</a></h5>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-subtitle-inner">-->
<!--                  <div class="em-content-subtitle">-->
<!--                    <span>Sales Supervisor</span>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="em-team-content-socials-inner">-->
<!--                  <div class="em-team-content-socials all_team_s_color">-->
<!--                    <a href="https://www.facebook.com/profile.php?id=100083074701518"><i-->
<!--                        class="icofont-facebook"></i></a>-->
<!--                    <a href="https://www.youtube.com/channel/UCxr_xUVMtb6JGRJUMQ5mWRw"><i-->
<!--                        class="icofont-youtube"></i></a>-->
<!--                    <a href="https://api.whatsapp.com/send?phone=8613929163028"><i class="icofont-whatsapp"></i></a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        &lt;!&ndash; kurigram_team_03 &ndash;&gt;-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--  &lt;!&ndash; kurigram_contact_area &ndash;&gt;-->
  <EmailForm/>

  <Footer/>
</template>

<style scoped lang="scss">

</style>